import React from 'react';

import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function DiscountTable({
  items,
  current,
  pageSize,
  loading,
  total,
  onRowClick,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      tableLayout="fixed"
      scroll={{ y: SCROLL_Y, x: '700px' }}
      pagination={{
        current,
        total,
        showSizeChanger: true,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { DiscountTable };
